<template>
  <div class="stream__item">
    <div class="stream__header">
      <div
        v-if="content.priority === 'high'"
        class="stream__header-priority"
      >!</div>
      <avatar
        :name="content.user | fullName"
        class="stream__header-avatar"
        size="48"
      />
      <div class="stream__header-content">
        <strong>{{ content.user | fullName }}</strong>
        in
        <router-link :to="{name: 'FoldersDetail', params: { folderId: content.folder.id } }">
          {{ content.folder.name }}
        </router-link>
        <span>
          {{ $t("c.streamItem.label.createdAt") }} {{ content.createdAt | fullDate }}
        </span>
      </div>
    </div>
    <div class="stream__body">
      <h2 class="add-margin-bottom">
        <post-link
          :post="content"
          class="content-list__link"
        >
          {{ content.title }}
        </post-link>
      </h2>

      <post-link
        v-if="articleImage(content)"
        :post="content"
        class="content-list__link"
      >
        <img
          :src="articleImage(content)"
          :alt="content.title"
          class="add-margin-bottom"
        >
      </post-link>

      <p>
        {{ content.teaserText }}
        <post-link
          :post="content"
        >{{ $t("c.streamItem.label.readMore") }}</post-link>
      </p>
    </div>
    <div class="stream__footer">
      <div class="stream__footer-left">
        <span
          v-if="content.source.name != ''"
          class="stream__source"
        >
          <font-awesome-icon
            icon="link"
          />
          <a :href="content.source.url">
            {{ content.source.name }}
          </a>
        </span>

        <span class="stream__tags">
          <span class="stream__tags-wrap">
            <font-awesome-icon
              class="stream__tags-icon"
              icon="tags"
            />
            <span
              v-for="(tag, index) in content.tags"
              :key="tag.slug"
              class="stream__tag"
            >
              <router-link :to="`/tag/${tag.slug}`">
                {{ tag.name }}
              </router-link>
              <span
                v-if="index + 1 < content.tags.length"
                class="stream__tag-comma"
              >
                ,
              </span>
            </span>
          </span>
        </span>
      </div>
      <div class="stream__footer-right">
        <font-awesome-icon
          icon="comments"
        />
        {{ content.commentsCount }}
      </div>
    </div>

    <hr
      v-if="index+1 === newItemsCount"
      class="stream__new-spacer"
    >
  </div>
</template>

<script>
import isBlank from 'is-blank'
import fullDate from '@/filters/fullDate'
import fullName from '@/filters/fullName'
import Avatar from '@/components/ui/Avatar'
import PostLink from '@/components/posts/PostLink'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  filters: {
    fullDate,
    fullName
  },
  components: {
    Avatar,
    PostLink,
    FontAwesomeIcon
  },
  props: {
    content: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    newItemsCount: {
      type: Number,
      default: null
    }
  },
  methods: {
    imageAttachments (content) {
      if (content && !isBlank(content.attachments)) {
        return content.attachments.filter(d => d.contentType.startsWith('image/'))
      }
    },
    articleImage (content) {
      const imageAttachments = this.imageAttachments(content)
      return imageAttachments &&
             imageAttachments[0] &&
             imageAttachments[0].url
    }
  }
}
</script>

<style lang="sass" scoped>
@import '~styles/imports'

.stream
  &__item
    border-top: 1px solid $color-grey-1
    padding: rem-calc(40 0)

  &__body
    margin-top: rem-calc($grid-gutter-width)
    margin-bottom: rem-calc(22)

    h2 a
      color: $color-black
      transition: $global-transition

      &:hover,
      &:focus
        color: var(--linkColor)
        text-decoration: none

      &:active
          color: var(--linkColorDark)

      p
        color: $color-grey-2

    .add-margin-bottom
      margin-bottom: rem-calc(22) !important

  &__header
    align-items: center
    color: $color-grey-2
    display: flex
    min-height: rem-calc(48)
    padding-left: rem-calc(60)
    position: relative

    &-content
      line-height: 1.5

      strong
        color: $color-black

      span
        font-size: 14px
        display: block

      a
        font-weight: 700

    &-priority
      +font-size(14, 22)
      background: red
      width: rem-calc(26)
      height: rem-calc(26)
      border-radius: 50%
      border: rem-calc(2) solid $color-white
      color: $color-white
      text-align: center
      font-weight: 900
      position: absolute;
      left: rem-calc(-12)
      top: rem-calc(-6)
      z-index: 1

    &-avatar
        position: absolute
        left: 0
        top: 0

  &__footer
    +font-size(14, 14)
    +clearfix()

    border-top: 1px dotted $color-grey-1
    color: $color-grey-2
    padding-top: rem-calc($grid-gutter-width)

    a
      color: $color-grey-2

    .fa
        margin-right: rem-calc(5)

    &-left
        float: left

    &-right
        float: right

  &__source + &__tags
    margin-left: rem-calc(25)

  &__tag
    text-transform: capitalize

  &__new-spacer
    overflow: visible; /* For IE */
    padding: 0;
    border: none;
    border-top: medium double var(--mainColor);
    text-align: center;
    margin-top: 70px
</style>




// WEBPACK FOOTER //
// src/components/stream/StreamItem.vue